import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { CardType } from './card-type.model';
import { CardTypePopupService } from './card-type-popup.service';
import { CardTypeService } from './card-type.service';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal , CRUD_ACTIONS, CARD_UNLIMITED_BOOKINGS_NUMBER, CARD_YEAR_IN_WEEKS } from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-card-type-dialog',
    templateUrl: './card-type-dialog.component.html'
})
export class CardTypeDialogComponent extends AbstractDialogComponent implements OnInit {

    cardType: CardType;
    authorities: any[];
    isSaving: boolean;
    validityPeriod: string;
    readonly MANUAL_DATES = 'MANUAL_DATES';
    readonly AUTOMATIC_BASED_ON_DURATION_AND_CREATION_DATE = 'AUTOMATIC_BASED_ON_DURATION_AND_CREATION_DATE';
    readonly AUTOMATIC_ANNUAL_AND_CREATION_DATE = 'AUTOMATIC_ANNUAL_AND_CREATION_DATE';

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private cardTypeService: CardTypeService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['cardType']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];

        if (this.cardType.defaultEndDate instanceof Date) {
            this.cardType.defaultEndDate = {
                year: this.cardType.defaultEndDate.getFullYear(),
                month: this.cardType.defaultEndDate.getMonth() + 1,
                day: this.cardType.defaultEndDate.getDate()
            };
            this.validityPeriod = this.MANUAL_DATES;
        }

        if (this.cardType.defaultStartDate instanceof Date) {
            this.cardType.defaultStartDate = {
                year: this.cardType.defaultStartDate.getFullYear(),
                month: this.cardType.defaultStartDate.getMonth() + 1,
                day: this.cardType.defaultStartDate.getDate()
            };
            this.validityPeriod = this.MANUAL_DATES;
        }

        if (this.cardType && this.cardType.defaultEndDate && this.cardType.defaultStartDate) {
            this.validityPeriod = this.MANUAL_DATES;
        } else if (this.cardType.package_)  {
            this.validityPeriod = this.AUTOMATIC_ANNUAL_AND_CREATION_DATE;
        } else {
            this.validityPeriod = this.AUTOMATIC_BASED_ON_DURATION_AND_CREATION_DATE;
        }

        this.loadSchools();
        this.loadCurrentSchool();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.cardType.id !== undefined) {
            this.cardTypeService.update(this.cardType)
            .delay(8000)
            .subscribe((res: CardType) =>
                this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.cardTypeService.create(this.cardType)
                .subscribe((res: CardType) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
        }
    }

    onUnlimitedClassesCheckboxChange(event: Event): void {
        if (this.cardType.unlimitedClasses) {
            this.cardType.maxAssistancesNum = CARD_UNLIMITED_BOOKINGS_NUMBER;
        }
    }

    onManualDatesValidityPeriodSelected(event: Event): void {
        this.cardType.package_ = false;
        this.cardType.duration = null;
        this.validityPeriod = this.MANUAL_DATES;
    }

    onAutomaticValidityFromCreationDateAndDurationSelected(event: Event): void {
        this.cardType.package_ = false;
        this.cardType.duration = null;
        this.validityPeriod = this.AUTOMATIC_BASED_ON_DURATION_AND_CREATION_DATE;
        this.cardType.defaultStartDate = null;
        this.cardType.defaultEndDate = null;
    }

    onAnnualValidityPeriodSelected(event: Event): void {
        this.cardType.package_ = true;
        this.cardType.duration = CARD_YEAR_IN_WEEKS;
        this.validityPeriod = this.AUTOMATIC_ANNUAL_AND_CREATION_DATE;
        this.cardType.defaultStartDate = null;
        this.cardType.defaultEndDate = null;
    }

    showDuration(): boolean  {
        return this.validityPeriod !== this.MANUAL_DATES;
    }

    showDefaultDates(): boolean {
        return this.validityPeriod === this.MANUAL_DATES;
    }

    showLoader(): boolean {
        return this.isSaving && this.cardType.id !== undefined;
    }

    private onSaveSuccess(result: CardType, action: String) {
        this.eventManager.broadcast({ name: 'cardTypeListModification', content: {
            action: action,
            content: result
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-card-type-popup',
    template: ''
})
export class CardTypePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private cardTypePopupService: CardTypePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.cardTypePopupService
                    .open(CardTypeDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.cardTypePopupService
                    .open(CardTypeDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card-type/card-type-dialog.component.ts